import { z } from 'zod'

/**
 * Откуда приходят данные: `mock` — моковый бэкенд `src/mocks` в браузере, `real` — NestJS.
 * По умолчанию `real`: боевой конфиг, забывший поле, не должен молча искать моки.
 * Моки физически есть только в дев-сервере и в сборке `pnpm build:mock`.
 */
export const apiModeSchema = z.enum(['mock', 'real'])

export const appConfigSchema = z.object({
  apiBaseUrl: z.string().min(1),
  wsUrl: z.string().min(1),
  env: z.enum(['dev', 'stage', 'prod']),
  api: apiModeSchema.default('real'),
  /**
   * Домены, которые в режиме `mock` идут на настоящий бэк: их хендлеры не поднимаются, и
   * запросы уходят на `apiBaseUrl`. Так экраны переезжают на NestJS по одному, остальные
   * живут на моках. Имена — группы хендлеров `src/mocks/handlers.ts`; в режиме `real`
   * поле не читается.
   */
  realDomains: z.array(z.string().min(1)).default([]),
  features: z.record(z.string(), z.boolean()).default({}),
  /**
   * Сколько ждать ответа API, мс (решение A-3). Дольше — запрос обрывается и показывается
   * как сбой связи. Величина окружения, а не константа: прокси стенда и прода отвечают по-разному.
   */
  requestTimeoutMs: z.number().int().positive().default(30_000),
  /** Политика обработки персональных данных — ссылка у согласия в запросе доступа. Нет — без ссылки. */
  privacyPolicyUrl: z.string().url().optional(),
})

export type ApiMode = z.infer<typeof apiModeSchema>
export type AppConfig = z.infer<typeof appConfigSchema>
